import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BroadcastService } from '../../../../../shared/services/broadcast.service';
import { FormService } from '../../../../../shared/services/form.service';
import { permissionsModel } from '../models/permissions.model';
import {PermissionsService} from '../../../../../services/permissions.service';

@Component({
  selector: 'app-create-edit-permissions-controller',
  templateUrl: './create-edit-permissions-controller.component.html',
  styleUrls: ['./create-edit-permissions-controller.component.scss']
})
export class CreateEditPermissionsControllerComponent implements OnInit {
  @Input() data: any = {};
  formGroup: RxFormGroup;
  isEdit = false;
  fields: any ={
    name: {
      type: 'input',
      options: {
        path: 'name',
        class: 'col-sm-12',
        label:{
          text: 'Nombre',
          class: 'col-sm-12'
        }
      }
    },
    guard_name: {
      type: 'input',
      options: {
        path: 'guard_name',
        class: 'col-sm-12',
        label:{
          text: 'Guard Name',
          class: 'col-sm-12'
        }
      }
    },
  }
  constructor(
    private cdr: ChangeDetectorRef,
    public modalRef: BsModalRef,
    private broadcast: BroadcastService,
    private formService: FormService,
    private permissionsService: PermissionsService
  ) {
    this.formService._formEvents
      .pipe(takeUntil(this.atComponentDestroy))
      .subscribe(form => {
        this.formGroup = form;
        this.cdr.detectChanges();
      });
  }
  private atComponentDestroy = new Subject();
  ngOnDestroy(): void {
    this.atComponentDestroy.next();
    this.atComponentDestroy.unsubscribe();
  }
  ngOnInit(): void {
    this.formService.transformIntoFormGroup(permissionsModel, this.data);
    if (this.data.id) {
      this.isEdit = true;
      this.formGroup.get('name').setValue(this.data.name);
      this.formGroup.get('guard_name').setValue(this.data.guard_name);
    }
    this.formGroup.valueChanges
    .pipe(takeUntil(this.atComponentDestroy))
    .subscribe(data => {
      this.cdr.markForCheck();
    });
  }
  submit(): void {
    this.permissionsService.createOrUpdate(this.formGroup, this.data?.id)
      .pipe(takeUntil(this.atComponentDestroy))
      .subscribe(data => {
        this.broadcast.reloadDataTable();
        this.modalRef.hide();
      }, error => {
        console.error("Error al enviar los datos:", error);
      });
  }
  toArray(enumme): any[] {
    return Object.keys(enumme)
      .map(key => ({ id: key, name: enumme[key] }));
  }
}
